/**
 * @ngdoc services
 * @memberof mercury.services
 * @name errorInterceptor
 * @description HTTP interceptor service for application wide handling of HTTP error responses.
 */
angular.module('mercury.services.errorsinterceptor', [])
.factory('errorInterceptor', ["$injector", "$q", "$timeout", "$window", function($injector, $q, $timeout, $window) {
  var $http;

  // Given the http config, attempt to retry the request.
  var _retryHttpRequest = function(config, deferred) {
    // Clear the existing Authorization header to the default will be applied.
    delete config.headers.Authorization;

    $http = $http || $injector.get('$http');
    $http(config).then(function(response) {
      deferred.resolve(response);
    }, function(response) {
      deferred.reject(response);
    });
  };

  // Given the error response, determine the right message to show to the user.
  var resolveErrorMessage = function(response) {
    switch (response.status) {
      case 0:
        return 'Loaded is currently unavaliable.';
      case 500:
        return '<p>Whoops, sorry something went wrong when we were trying to complete that for you.</p><p>Help us get this fixed by sending a quick message' +
          ' to our <a style="color: red" feedback>support team</a> on what you were doing at the time things went astray.</p>';
      case 400:
        return (response.data.modelState) ? 'Some of the fields are invalid. Please fix these before continuing.' : response.data.message;
      case 404:
        return (response.data) ? response.data.message :
          'Unable to find this page. This could be because it belongs to different company than your current one or it no longer exists.';
      case 409:
        return (response.data) ? response.data.description :
          'This action could not be completed due to a duplication error. Please contact support.';
      default:
        return (response.data) ? response.data.message : 'This action could not be completed due to an unknown error. Please contact support.';
    }
  };

  /**
   * @memberof errorInterceptor
   */
  function responseError(response) {
    var deferred = $q.defer();
    var $state = $injector.get('$state');

    // Determine the action that should be taken, based on the status code returned.
    switch (response.status) {
      case 401:
        var authService = $injector.get('authService');

        //The current stored auth is invalid so delete it.
        authService.refreshCredentials()
        .then(function() {
          _retryHttpRequest(response.config, deferred);
        }, function() {
          $window.location.assign('/login?reason=401&redirect=' + $window.location.hash);
        });
      break;
      case 402:
        $state.go('Settings.CompanyExpired');
      break;
      case 403:
        $state.go('FullWidth.ErrorPermission');
      break;
      default:
        // If an alert is opened by the controller, this alert will be ignored.
        response.defaultAlertTimeout = $timeout(function() {
          // Alert the user.
          var dialog = $injector.get('dialog');
          var error;
          try {
            error = angular.fromJson(resolveErrorMessage(response));
          } catch (e) {
            error = resolveErrorMessage(response);
          }
          if (angular.isObject(error)) {
            dialog.alert(error.message);
            if (error.redirect) {
              $state.go(error.redirect);
            }
          } else {
            if (error) {
              dialog.alert(error);
            }
          }
        }, 100);

        deferred.reject(response);
      break;
    }

    return deferred.promise;
  }

  return {
    responseError: responseError
  };
}]);
